import SoftTagManager from "@/features/softTag/softTag";

const SoftTagPage = () => {
  return (
    <section className="flex flex-row w-full pt-2">
        <SoftTagManager />
      </section>
  );
};

export default SoftTagPage;
